import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../api";
import LegalFooter from "../components/LegalFooter";
import PasswordInput from "../components/PasswordInput";
import storage from "../nativeStorage";

// Desktop app is organiser-only -- no Player tab there at all.
const isElectron = typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().includes("electron");

export default function Login() {
  const [tab, setTab] = useState("organiser");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const switchTab = (t) => { setTab(t); setError(""); setEmail(""); setPassword(""); };

  const handleSubmit = async () => {
    setLoading(true); setError("");
    try {
      if (tab === "organiser" || tab === "club") {
        // A Club account IS a society under the hood (same app, same
        // features -- a club just gets there through its own labeled tab
        // and went through an approval step at registration). Identical
        // login path to the organiser tab.
        const res = await api.post("/auth/login", { email, password, expected_type: tab === "club" ? "club" : "society" });
        if (res.data.superadmin) {
          storage.setItem("token", res.data.token);
          storage.setItem("superadmin", "true");
          window.location.href = "/superadmin/dashboard";
          return;
        }
        storage.setItem("token", res.data.token);
        window.location.href = res.data.must_change_password ? "/change-password?forced=true" : "/players";
      } else {
        const res = await api.post("/player/login", { email, password });
        const data = res.data;
        storage.setItem("player_token", data.token);
        storage.setItem("player_name", data.player.name || data.player.email);
        navigate(data.must_change_password ? "/player/change-password?forced=true" : "/player/dashboard");
      }
    } catch(err) {
      setError(err.response?.data?.error || "Invalid email or password");
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f0fdf4", display: "flex", alignItems: "center", justifyContent: "center", padding: "16px" }}>
      <div style={{ background: "white", padding: "32px", borderRadius: "16px", boxShadow: "0 4px 24px rgba(0,0,0,0.10)", width: "100%", maxWidth: "420px" }}>

        <div style={{ textAlign: "center", marginBottom: "24px" }}>
          <div style={{ width: "64px", height: "64px", background: "#14532d", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 12px", fontSize: "28px" }}>⛳</div>
          <h1 style={{ margin: 0, fontSize: "22px", fontWeight: "800", color: "#14532d" }}>Golf Society Manager</h1>
          <p style={{ margin: "6px 0 0", fontSize: "14px", color: "#6b7280" }}>Sign in to your account</p>
        </div>

        <div style={{ display: "flex", gap: "8px", marginBottom: "24px" }}>
          <button onClick={() => switchTab("organiser")}
            style={{ flex: 1, border: tab === "organiser" ? "2px solid #2563eb" : "2px solid #e5e7eb", borderRadius: "10px", padding: "12px", textAlign: "center", background: tab === "organiser" ? "#eff6ff" : "white", cursor: "pointer" }}>
            <div style={{ fontSize: "24px" }}>🏢</div>
            <div style={{ fontSize: "12px", fontWeight: "700", color: tab === "organiser" ? "#2563eb" : "#9ca3af", marginTop: "4px" }}>Society / Organiser</div>
          </button>
          {!isElectron && (
            <button onClick={() => switchTab("player")}
              style={{ flex: 1, border: tab === "player" ? "2px solid #166534" : "2px solid #e5e7eb", borderRadius: "10px", padding: "12px", textAlign: "center", background: tab === "player" ? "#f0fdf4" : "white", cursor: "pointer" }}>
              <div style={{ fontSize: "24px" }}>🏌️</div>
              <div style={{ fontSize: "12px", fontWeight: "700", color: tab === "player" ? "#166534" : "#9ca3af", marginTop: "4px" }}>Player Portal</div>
            </button>
          )}
          {!isElectron && (
            <button onClick={() => switchTab("club")}
              style={{ flex: 1, border: tab === "club" ? "2px solid #92400e" : "2px solid #e5e7eb", borderRadius: "10px", padding: "12px", textAlign: "center", background: tab === "club" ? "#fffbeb" : "white", cursor: "pointer" }}>
              <div style={{ fontSize: "24px" }}>📍</div>
              <div style={{ fontSize: "12px", fontWeight: "700", color: tab === "club" ? "#92400e" : "#9ca3af", marginTop: "4px" }}>Golf Club</div>
            </button>
          )}
        </div>

        {error && <div style={{ background: "#fef2f2", border: "1px solid #fca5a5", color: "#dc2626", padding: "10px 14px", borderRadius: "8px", marginBottom: "16px", fontSize: "14px" }}>{error}</div>}

        <div style={{ marginBottom: "16px" }}>
          <label style={{ display: "block", fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "6px" }}>Email</label>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key === "Enter" && handleSubmit()}
            placeholder="your@email.com"
            style={{ width: "100%", border: "1.5px solid #d1d5db", borderRadius: "8px", padding: "11px 14px", fontSize: "15px", boxSizing: "border-box" }} />
        </div>

        <div style={{ marginBottom: "24px" }}>
          <label style={{ display: "block", fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "6px" }}>Password</label>
          <PasswordInput value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === "Enter" && handleSubmit()}
            placeholder="••••••••"
            style={{ width: "100%", border: "1.5px solid #d1d5db", borderRadius: "8px", padding: "11px 14px", fontSize: "15px", boxSizing: "border-box" }} />
        </div>

        <button onClick={handleSubmit} disabled={loading}
          style={{ width: "100%", background: loading ? "#86efac" : tab === "organiser" ? "#2563eb" : tab === "player" ? "#166534" : "#92400e", color: "white", fontWeight: "700", fontSize: "16px", padding: "13px", borderRadius: "8px", border: "none", cursor: loading ? "not-allowed" : "pointer", marginBottom: "16px" }}>
          {loading ? "Signing in..." : tab === "organiser" ? "Sign In" : tab === "player" ? "Sign In as Player" : "Sign In as Club"}
        </button>

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "8px" }}>
          {tab === "organiser" ? (
            <>
              <p style={{ margin: 0, fontSize: "14px", color: "#6b7280" }}>No account? <Link to="/register" style={{ color: "#2563eb", fontWeight: "600", textDecoration: "none" }}>Register here</Link></p>
              <Link to="/forgot-password" style={{ fontSize: "14px", color: "#2563eb", fontWeight: "600", textDecoration: "none" }}>Forgot password?</Link>
            </>
          ) : tab === "player" ? (
            <>
              <button onClick={() => navigate("/player/register")} style={{ background: "none", border: "none", fontSize: "14px", color: "#166534", fontWeight: "600", cursor: "pointer", padding: 0 }}>New player? Register here</button>
              <button onClick={() => navigate("/forgot-password")} style={{ background: "none", border: "none", fontSize: "14px", color: "#166534", fontWeight: "600", cursor: "pointer", padding: 0 }}>Forgot password?</button>
            </>
          ) : (
            <button onClick={() => navigate("/register?type=club")} style={{ background: "none", border: "none", fontSize: "14px", color: "#92400e", fontWeight: "600", cursor: "pointer", padding: 0 }}>New club? Register here</button>
          )}
        </div>

        <div style={{ marginTop: "24px" }}>
          <LegalFooter />
        </div>
      </div>
    </div>
  );
}
